import { useEffect } from "react";

const Home = () => {
    useEffect(() => {
        window.location.href = 'https://singletrack.com/?ref=re';
    }, []);

    return <div>Redirecting to Singletrack.com</div>;
};

export default Home;